// Shared display helpers for AI proposal statuses used by the list views and the detail dialog.

// German labels for the backend status values.
// `applying` is a transient status the backend sets while a decided proposal is
// still being applied (between pending and applied/failed).
export const AI_PROPOSAL_STATUS_LABELS = {
  pending: 'Ausstehend',
  applying: 'In Bearbeitung',
  applied: 'Angewendet',
  rejected: 'Abgelehnt',
  failed: 'Fehlgeschlagen',
  // The submitting AI retracted the proposal before anyone decided on it.
  withdrawn: 'Zurückgezogen',
};

// MUI Chip colors per status
export const AI_PROPOSAL_STATUS_CHIP_COLORS = {
  pending: 'warning',
  applying: 'info',
  applied: 'success',
  rejected: 'default',
  failed: 'error',
  withdrawn: 'default',
};

// Returns the German label for a status, falling back to the raw value
export const getAiProposalStatusLabel = status =>
  AI_PROPOSAL_STATUS_LABELS[status] || status || '—';

// Returns the MUI Chip color for a status, degrading to 'default' for unknown values
export const getAiProposalStatusChipColor = status =>
  AI_PROPOSAL_STATUS_CHIP_COLORS[status] || 'default';
